export default __webpack_public_path__ + "static/how-to-maximise-a-short-annual-leave-holiday-calculate-your-time-8641c524dd3447623b302fdc0c8fe742.jpg";